import { render } from "./example.vue?vue&type=template&id=f199e4b8"
import script from "./example.vue?vue&type=script&lang=js"
export * from "./example.vue?vue&type=script&lang=js"

import exportComponent from "/private/var/web/vivadante.test/src/wp-content/themes/altrama-enti-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__